import React, { useEffect, useContext, useState, useRef } from 'react'
import { Box, } from '@mui/material'

import SuperAdminContext from "../../../contexts/SuperAdminContext"

const EditableField = ({type, buttonName, field, isEditor, sx, onInputChange, stopClickPropagation}) => {

  let superAdminContext = null
  if (isEditor) {
    superAdminContext = useContext(SuperAdminContext)
  }

  const [isTyping, setIsTyping] = useState(false)
  const [text, setText] = useState(field)

  useEffect(() => {
    if (!isTyping && text !== field) {
      setText(field)
    }
  }, [isTyping, text, field])

  const onInput = (e) => {
    setIsTyping(true)
    if (buttonName) {
      //si on a buttonName, c'est un bouton éditable
      let format = superAdminContext?.content?.chapitre[superAdminContext?.adminPlayerIndexes?.chapitre]?.partie[superAdminContext?.adminPlayerIndexes?.partie]?.sequence[superAdminContext?.adminPlayerIndexes?.sequence]
      let data = format[type]
      data.text = e.currentTarget.textContent
      superAdminContext?.onSequenceChange(
        type,
        data,
        superAdminContext?.adminPlayerIndexes
      )
    } else {
      if (typeof type === "string") { //pour field normaux
        superAdminContext?.onSequenceChange(
          type,
          e.currentTarget.textContent,
          superAdminContext?.adminPlayerIndexes
        )
      } else if (typeof type === "object" && type?.length === 2) {
        //pour fin de formation
        try {
          let newFormation = JSON.parse(JSON.stringify(superAdminContext?.content))
          newFormation[type[0]][type[1]] = e.currentTarget.textContent

          superAdminContext?.setContent(newFormation)
          superAdminContext?.setPlayerHasChanged(true)
        } catch(e) { console.log(e) }
      } else if (typeof type === "object" && type?.length === 3) {
        //pour format Quizz et format Diag
        try {
          let format = superAdminContext?.content?.chapitre[superAdminContext?.adminPlayerIndexes?.chapitre]?.partie[superAdminContext?.adminPlayerIndexes?.partie]?.sequence[superAdminContext?.adminPlayerIndexes?.sequence]
          let data = format[type[0]]
          data[type[1]][type[2]] = e.currentTarget.textContent

          superAdminContext?.onSequenceChange(
            type[0],
            data,
            superAdminContext?.adminPlayerIndexes
          )
        } catch(e) { console.log(e) }
      } else if (typeof type === "object" && type?.length === 5) {
        //pour format Diag
        try {
          let format = superAdminContext?.content?.chapitre[superAdminContext?.adminPlayerIndexes?.chapitre]?.partie[superAdminContext?.adminPlayerIndexes?.partie]?.sequence[superAdminContext?.adminPlayerIndexes?.sequence]
          let data = format[type[0]]
          if (data) {
            //on cherche la categorie
            let findCat = data?.find((el) => el.key === type[1])
            if (findCat) {
              findCat[type[2]][type[3]][type[4]] = e.currentTarget.textContent
            }

            superAdminContext?.onSequenceChange(
              type[0],
              data,
              superAdminContext?.adminPlayerIndexes
            )
          }
        } catch(e) { console.log(e) }
      }
    }
  }
  const onBlur = (e) => {
    setIsTyping(false)
    setText(e.currentTarget.textContent)
  }

  if (isEditor) {
    return (
      <Box
        contentEditable="plaintext-only"
        suppressContentEditableWarning={true}
        onInput={onInputChange ? onInputChange : onInput}
        onBlur={onBlur}
        sx={{...sx, minWidth:"10px"}}
        dangerouslySetInnerHTML={{ __html: text }}
        onClick={(e) => {
          if (stopClickPropagation) {
            e.stopPropagation()
          }
        }}
      />
    )
  } else {
    return (
      <Box
        sx={{...sx, whiteSpace: sx?.whiteSpace?sx.whiteSpace:"pre-line", userSelect:"none"}}
        dangerouslySetInnerHTML={{ __html: field }}
      />
    )
  }
}

export default EditableField
